import basePath from "base_path";
import ActionTypes from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";

export default function clauseTopicLogsFetch(requestor) {
  return createReduxPromiseAction(
    ActionTypes.CLAUSE_TOPIC_LOGS_FETCH,
    (organisationId, topicId, clausepartId) =>
      requestor
        .get(
          `${basePath}/organisation/${organisationId}/topic/${topicId}/clausepart/${clausepartId}/logs`,
          {withCredentials: true},
        )
        .then(response => response.data),
  );
}
